// ViewerComponent
import { Component, OnInit, OnDestroy, ViewEncapsulation, ElementRef } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { SharedService } from '../shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NavbarService } from '../navbar/navbar.service';

declare let jQuery: any;
declare let UserInterface: any;
declare let HWV_CSR: any;
declare let unload: any;
declare let killPreviousViewer: any;

@Component({
  selector: 'viewer',
  templateUrl: 'viewer.component.html',
  providers: [SharedService],
  encapsulation: ViewEncapsulation.Emulated
})
export class ViewerComponent implements OnInit, OnDestroy, AfterViewInit {
  hwv: any;
  userInterface: any;
  _service: any;
  hwfurl: string;
  private file: string;
  isvalid: boolean = true;
  tenantid: string = '';

  constructor(private service: SharedService,
              private router: Router,
              private route: ActivatedRoute,
              public navService: NavbarService) {
    this._service = service;
    console.log('SERVICE:', service);
  }

  ngOnInit() {
    this.navService.hide();
    console.log('In Viewer Component. URL:', this.router.url);
    this.tenantid = localStorage.getItem('mr_tenantid');
    this.hwfurl = localStorage.getItem('hwfurl');
  }

  ngAfterViewInit() {
    console.log('In ngAfterViewInit Component');
    this.loadHWF();
  }

  ngOnDestroy() {
  }

  loadHWF() {
    console.log('Here is the HWFURL:', this.hwfurl);
    this.hwv = new HWV_CSR('theCanvas');
    console.log('Now creating the UI');
    this.userInterface = new UserInterface(this.hwv, this.hwfurl);
    console.log('hwv:', this.hwv);
    console.log('UI:', this.userInterface);
    // this.hwv.start();
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/Viewer/viewer.component.ts